import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';

import {MatAccordion} from '@angular/material/expansion';

// Services
import { AdminService, LineType, SubLineType } from '../../services/admin.service'
import { ObjectListService } from 'src/app/services/object-list.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatCard, MatCardTitle } from '@angular/material/card';
import { MatFormField, MatLabel, MatHint } from '@angular/material/form-field';
import { MatSelect, MatOption } from '@angular/material/select';
import { NgFor, NgIf } from '@angular/common';
import { MatInput } from '@angular/material/input';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-object-dialog',
    templateUrl: './object-dialog.component.html',
    styleUrls: ['./object-dialog.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, MatDialogTitle, CdkScrollable, MatDialogContent, MatCard, MatCardTitle, MatFormField, MatLabel, MatSelect, NgFor, MatOption, MatInput, CdkTextareaAutosize, MatCheckbox, NgIf, MatHint, MatDialogActions, MatButton, MatProgressSpinner]
})
export class ObjectDialogComponent implements OnInit {
  @ViewChild(MatAccordion) accordion: MatAccordion;  
  title:string;
  objFormGroup: UntypedFormGroup;
  disable: boolean;
  selectedSite: string;

  isSaving:boolean=false;
  isLoading:boolean=false;

  plantList: any;
  problemGroups: any;
  teamGroups: any;
  timerGroups: any;
  trSchemaList: any;
  showCountObjectID: boolean;
  data: ObjectConfigType;

  selectedLineID: number;
  lineOverride:boolean; // TEMPORARY, will remove with ITMFG-4xxxx
  sharedProblemGroup:boolean;

  lineList:LineType[];
  lineListFiltered:LineType[];
  subLineList:SubLineType[];
  subLineListFiltered:SubLineType[];

  constructor(
    public dialogRef: MatDialogRef<ObjectDialogComponent>,
    private adminService: AdminService,
    private fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public inData: ObjectConfigType,
    private svcObjectList: ObjectListService,
  ) {
    console.log("Open Dialog", inData);

    this.data = inData['objData'];
    console.log("this.data.​ProbNoteReq", this.data.​ProbNoteReq);

    if (this.data.isEdit) {
      this.title = "Edit Object"; 
    } else {
      this.title = "Create Object";
    }

    this.adminService.plantList().subscribe((
      out => {
        this.plantList = out.Body;
        if(this.data.isEdit) {
          this.selectPlant();
        }             
      }
    ));

    this.adminService.lineList().subscribe((
          out => {
            this.lineList = out.Body.Lines;
            this.subLineList = out.Body.SubLines;
            this.filterLines();
          }
    ));

    this.adminService.teamGroupsGet('ALL').subscribe((
      out => {
        this.teamGroups = out.Body.sort((n1,n2) => {
              if (n1.Description > n2.Description) {
                  return 1;
              }
          
              if (n1.Description < n2.Description) {
                  return -1;
              }
          
              return 0;
          });
        
        this.teamGroups.unshift({"Team": ""});
      }
    ));    

    this.adminService.trSchemaList().subscribe((
      out => {
        this.trSchemaList = out.Body;
      }
    ));    

    this.disable = this.data.isEdit;

    if (this.data.PlantName == "MISSING PLANT") {
      this.disable = false;
    }

    this.timerGroups = ["Blocked", "Starved", "Running/Warning"];
    
    let excludeTimerGroups:string[] = [];

    if (this.data.isEdit) {
      this.showCountObjectID = this.data.ManCount == "2" ? true : false;
      excludeTimerGroups = this.data.ExcludeTimerGroups.split(",");
    }

    if (this.data.isEdit && this.data.lineID == -1 && this.data.Section != "") {
      this.lineOverride = true;
    } else {
      this.lineOverride = false;
    }

    this.sharedProblemGroup = this.data.ProblemGroupType == 'SHARED' ? true : false;

    console.log("data", this.data);
    console.log("this.data.​ProbNoteReq", this.data.​ProbNoteReq);
    this.objFormGroup = this.fb.group({
      PlantName: new UntypedFormControl({value: this.data.PlantName, disabled: this.disable}, Validators.required),
      ObjectID: new UntypedFormControl({value: this.data.ObjectID, disabled: this.disable}, Validators.required),
      EAMAsset: new UntypedFormControl({value: this.data.EAMAsset, disabled: false}),
      Description: new UntypedFormControl({value: this.data.Description, disabled: false}),
      line: new UntypedFormControl({value: this.data.lineID, disabled: false}, Validators.required),
      subline: new UntypedFormControl({value: this.data.subLineID, disabled: false}, Validators.required),
      line_override: new UntypedFormControl({value: this.lineOverride, disabled: false}),
      Section: new UntypedFormControl({value: this.data.​Section, disabled: false}),
      SubSection: new UntypedFormControl({value: this.data.SubSection, disabled: false}),
      ObjectType: new UntypedFormControl({value: this.data.ObjectType, disabled: false}, Validators.required),
      ManCount: new UntypedFormControl({value: this.data.ManCount, disabled: false}, Validators.required),
      ManProb: new UntypedFormControl({value: this.data.ManProb, disabled: false}, Validators.required),
      ProbLevelReq: new UntypedFormControl({value: this.data.ProbLevelReq, disabled: false}, Validators.required),
      ProbNoteReq: new UntypedFormControl({value: this.data.​ProbNoteReq, disabled: false}, Validators.required),
      ProblemGroup: new UntypedFormControl({value: this.data.​ProblemGroup, disabled: false}),
      SharedProblemGroup: new UntypedFormControl({value: this.sharedProblemGroup, disabled: false}),
      TeamGroup: new UntypedFormControl({value: this.data.TeamGroup, disabled: false}),
      ExcludeTimerGroups: new UntypedFormControl({value: excludeTimerGroups, disabled: false}),
      IgnoreSeconds: new FormControl<number>({value: this.data.IgnoreSeconds, disabled: false}, [Validators.required, Validators.min(0), Validators.pattern('[0-9]*')]),
      CountObjectID: new UntypedFormControl({value:this.data.CountObjectID, disabled: false})
    });

   }

  ngOnInit(): void {
  }

  getProblemGroupList() {
    this.adminService.problemGroupList(this.selectedSite).subscribe((
      out => {
        this.problemGroups = out.Body;
        
        this.isLoading = false;
      }
    ));
  }

  onChangeCountCollection() {
    let rawFormData = this.objFormGroup.getRawValue();
    this.showCountObjectID = rawFormData.ManCount == "2" ? true : false;
  }

  selectPlant() {
    const d = this.objFormGroup.getRawValue().PlantName
    console.log("SELECT() BEFORE", d);
    console.log("SELECT()", this.plantList);
    for (let plant in this.plantList) {
      if (this.plantList[plant].display_name == d) {
        //this.selectedSite = this.plantList[plant].display_name.substring(0,3);
        this.selectedSite = this.plantList[plant].display_name;
        this.filterLines();
        this.getProblemGroupList();
      }
    }
  }

  filterLines() {
      if (this.selectedSite && this.lineList != undefined) {
        this.lineListFiltered = this.lineList.filter((line) => line.display_name == this.selectedSite);
        this.selectLine();
      }
  }

  selectLine() {
      const d = this.objFormGroup.getRawValue().line;
      console.debug("Line", d);
      this.selectedLineID = d;

      if (this.selectedLineID != undefined && this.selectedLineID != -1) {
        this.subLineListFiltered = this.subLineList.filter((subline) => subline.line_id == this.selectedLineID);
        this.subLineListFiltered.unshift({line_id: this.selectedLineID, subline_id: -1, subline: "<None>" });

        // Set Section - Will be removed with ITMFG-44979 when override is removed
        let lineDesc = this.lineList.filter((line) => line.line_id == this.selectedLineID)[0]['line'];
        console.log("LineDesc", lineDesc);
        this.objFormGroup.patchValue({ Section: lineDesc, SubSection: '' });

      } else {
        this.subLineListFiltered = [];
      }
    }

    /**
     * TEMPORARY: WILL REMOVE WITH ITMFG-45218
     */
    selectSubLine() {
      const d = this.objFormGroup.getRawValue().subline;
      console.debug("SubLine", d);
      let subLineID:number = d;

      if (subLineID != -1) {
        let subLineDesc = this.subLineList.filter((subline) => subline.subline_id == subLineID)[0]['subline'];
        console.log("LineDesc", subLineDesc);
        this.objFormGroup.patchValue({ SubSection: subLineDesc });
      } 
    }

    /**
     * TEMPORARY: WILL REMOVE WITH ITMFG-45218
     */
    selectOverride() {
      const d = this.objFormGroup.getRawValue().line_override;
      this.lineOverride = d;

      if (this.lineOverride) {
        this.objFormGroup.patchValue({ line: -1, subline: -1, Section: '', SubSection: '' });

        this.selectLine();
      }
    }

  selectSharedProblemGroup() {
    const d = this.objFormGroup.getRawValue().SharedProblemGroup;
    this.sharedProblemGroup = d;
  }

  saveData(): void {
    console.log("Save Data", this.objFormGroup)
    this.isSaving = true;
    let bClose:boolean = true;
    let objectlistreload:boolean = true;
    
    let rawFormData = this.objFormGroup.getRawValue();
    console.log("rawFormData.Description", rawFormData.Description);

    let Description:string = "";
    let Section:string = "";
    let SubSection:string = rawFormData.SubSection == undefined ? "" : rawFormData.SubSection ;
    let TeamGroup:number;
    let ObjectType:string = "";
    let ExcludeTimerGroups:string = rawFormData.ExcludeTimerGroups.join(",");
    let CountObjectID:string = "";
    let ProblemGroup = rawFormData.SharedProblemGroup ? rawFormData.ProblemGroup : -1;

    Description = rawFormData.Description == undefined ? "" : rawFormData.Description ;
    Section = rawFormData.Section == undefined ? "" : rawFormData.Section ;
    TeamGroup = rawFormData.TeamGroup == undefined ? "" : rawFormData.TeamGroup;
    ObjectType = rawFormData.ObjectType == undefined ? "" : rawFormData.ObjectType ;

    if (rawFormData.CountObjectID == undefined || rawFormData.ManCount != 2) {
      CountObjectID = "";
    } else {
      CountObjectID = rawFormData.CountObjectID;
    }
    

    if (bClose) {
      let data:ObjectConfigType = {
        "ObjectID": rawFormData.ObjectID,
        "EAMAsset": rawFormData.EAMAsset,
        "ObjectType": rawFormData.ObjectType,
        "Description": Description,
        "PlantName": this.selectedSite,
        "ManCount": rawFormData.ManCount,
        "CountObjectID": CountObjectID,
        "ManProb": rawFormData.ManProb,
        "ProbNoteReq": rawFormData.ProbNoteReq,
        "ProbLevelReq": rawFormData.ProbLevelReq,
        "ProblemGroup": ProblemGroup,
        "TeamGroup": TeamGroup,
        "ExcludeTimerGroups": ExcludeTimerGroups,
        "IgnoreSeconds": rawFormData.IgnoreSeconds,
        "lineID": rawFormData.line,
        "subLineID": rawFormData.subline,
        "Section": Section,
        "SubSection": SubSection      
       }

      this.adminService.editObject(data).subscribe(
        (out) => {
          this.svcObjectList.objectList(objectlistreload);
          this.isSaving = false;
          this.dialogRef.close(this.selectedSite);
        },
        (err) => {
          this.isSaving = false;
          console.error("Something failed", err);
        }
      );
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }  

}

export interface ObjectConfigType {
  isEdit?: boolean;
  PlantName?: string;
  ObjectID?: string;
  EAMAsset?: string;
  Description?: string;
  ManCount?: string;
  CountObjectID?: string;
  ManProb?: number;
  ProbLevelReq?: number;
  ProbNoteReq?: number;
  ProblemGroup?: number;
  ProblemGroupType?: string;
  TeamGroup?: number;
  ObjectType?: string; 
  ExcludeTimerGroups?: string;
  IgnoreSeconds?: number;
  lineID?: number;
  subLineID?: number;
  Section?: string;
  SubSection?: string;
}